// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rLox","content":"styles_content__2tTiY","tableWrap":"styles_tableWrap__1L_iy"};